import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { useDispatch } from "react-redux";
import { GetPost } from "../../api/postapi";
import UseWritePost from "../../hooks/UseWritePost";
import { Postcommentype } from "../../interface/interface";
import { PeriodForm } from "../../lib/lib";
import { ToastChange } from "../../reducers/config";
import "./css/index.css";

const bbs_id = 6;

/** 이용약관 관리 페이지 */
function Policy() {
  const dispatch = useDispatch();
  const [data, setdata] = useState<Postcommentype[]>(btn_layout);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [Index, setIndex] = useState(0);
  const [WritePost] = UseWritePost("이용약관이 변경 되었습니다.");
  const [Desc, setDesc] = useState("");
  const [content, setContent] = useState("");
  const TypeChange = useCallback(
    (index: number) => {
      setIndex(index);
    },
    [data]
  );

  const SavePolicy = useCallback(() => {
    const { ctts_tit, ctts_ctg_cd, ctts_id } = data[Index];
    WritePost(
      {
        bbs_id,
        ctts_tit: ctts_tit,
        ctts_ctts: content,
        ctts_desc: Desc,
        ctts_ctg_cd: ctts_ctg_cd,
        ctts_id: ctts_id,
      },
      false
    ).then((result) => {
      if (result) {
        let arr = data.slice();
        let obj = Object.assign({}, arr[Index]);
        obj.ctts_desc = Desc;
        obj.ctts_ctts = content;
        arr[Index] = obj;
        setdata(arr);
      } else {
        dispatch(
          ToastChange({
            active: true,
            content: "약관을 저장하지 못했습니다",
          })
        );
      }
    });
  }, [WritePost, content, Desc, Index, data]);
  useEffect(() => {
    const { ctts_ctts, ctts_desc } = data[Index];
    setContent(ctts_ctts);
    setDesc(ctts_desc);
    setIsOpen(false);

    return () => {};
  }, [Index, data]);

  useLayoutEffect(() => {
    GetPost(bbs_id, 1).then(({ data: { lst } }) => {
      setdata(lst);
    });
    return () => {};
  }, []);

  return (
    <main className="policy">
      <div className="wrapper">
        <div className="policy-title-wrapper">
          <div className="left">
            <div className="title">약관 관리</div>
            <div className="type-box-wrapper">
              <div className={`type_box ${isOpen ? "open" : ""}`}>
                <button
                  className="now"
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                >
                  <div className="type">{data[Index].ctts_tit}</div>
                  <img
                    className="buttontype"
                    src="/assets/common/button.svg"
                    alt="arrow"
                  />
                </button>
                {data.map(({ ctts_tit }, idx) => {
                  return (
                    <button
                      key={idx}
                      onClick={() => {
                        TypeChange(idx);
                      }}
                    >
                      {ctts_tit}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="right">
            <button className="save-btn" onClick={SavePolicy}>
              <div className="title">저장하기</div>
            </button>
          </div>
        </div>
        <div className="line"></div>
        <div className="policy_wrapper">
          <div className="subpolicy">
            <div className="title">{}</div>
            <div className="sub">시행일</div>
            <input
              type="text"
              className="input"
              value={Desc}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length < 11) {
                  setDesc(PeriodForm(value));
                }
              }}
            />
          </div>
          <div className="mainpolicy">
            <div className="sub">내용</div>
            <textarea
              className="input"
              value={content}
              onChange={(e) => {
                setContent(e.target.value);
              }}
            ></textarea>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Policy;

const btn_layout: Postcommentype[] = [
  {
    ctts_tit: "개인정보 수집 및 이용동의",
    ctts_ctg_cd: "AGR_INFO",
    ctts_ctts: "",
    ctts_desc: "",
    ctts_id: "21",
  },
  {
    ctts_tit: "마케팅 활용 및 광고정보 수신동의",
    ctts_ctg_cd: "ARG_MAT",
    ctts_ctts: "",
    ctts_desc: "",
    ctts_id: "22",
  },
  {
    ctts_tit: "서비스 이용 약관",
    ctts_ctg_cd: "AGR_AD",
    ctts_ctts: "",
    ctts_desc: "",
    ctts_id: "23",
  },
];
